import React, { useState } from 'react'
import { PreviewPaneContainer, PreviewPaneHolder } from './style'

function PreviewPane({ setPane, link }) {
    return (
        <>
            <PreviewPaneContainer onClick={() => setPane(false)}>
                <div className='overlay'></div>
                <PreviewPaneHolder>
                    <iframe src={link} />
                </PreviewPaneHolder>
            </PreviewPaneContainer>
        </>
    )
}

export default PreviewPane